import UserProgramProfileModal from './container'

export default UserProgramProfileModal
